import { cn } from "cn"

import {
  selectOrganization,
  selectOrgHasNewsletter,
} from "@/lib/storage/app-slice"
import {
  selectOrgNewsletterOptIn,
  setOrgNewsletterOptIn,
} from "@/lib/storage/auth-slice"
import { useAppDispatch, useAppSelector } from "@/lib/storage/hooks"
import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"

export function OrgNewsletterCheckbox({ className }: { className?: string }) {
  const dispatch = useAppDispatch()
  const organization = useAppSelector(selectOrganization)
  const hasNewsletter = useAppSelector(selectOrgHasNewsletter)
  const checked = useAppSelector(selectOrgNewsletterOptIn)

  if (!organization || !hasNewsletter) return null

  return (
    <Label className={cn("py-0", className)}>
      <Checkbox
        checked={checked}
        onCheckedChange={(checked) =>
          dispatch(setOrgNewsletterOptIn(checked === true))
        }
      />
      <span>
        {organization.properties.newsletter_subscription_label ||
          `Subscribe to the ${organization.name} newsletter`}
      </span>
    </Label>
  )
}
